"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData;
    if (typeof value !== 'string') {
      return value;
    }
    var max = typeof settings.maxLength !== 'undefined' ? settings.maxLength : 40;
    var tail = typeof settings.tail !== 'undefined' ? settings.tail : 5;
    var len = value.length;
    if (len > max) {
      var tooltipValue = /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          wordWrap: 'break-word'
        }
      }, value);
      var shortened = /*#__PURE__*/_react["default"].createElement("span", null, value.slice(0, max - (tail + 3)), "\u2026", value.slice(-tail));
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: tooltipValue,
        size: "small"
      }, shortened);
    }
    return value;
  };
};